import EmploymentWrapper from 'features/signup/Employment/EmploymentWrapper';
import React from 'react';

export default function Page() {
  return <EmploymentWrapper />;
}
